import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AdminAuthService } from '../services/admin-auth.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);

  // Check if user is authenticated (regular or admin)
  const isRegularAuth = auth.isAuthenticated();
  const isAdminAuth = adminAuth.isAdminAuthenticated();

  if (!isRegularAuth && !isAdminAuth) {
    router.navigate(['/auth/login']);
    return false;
  }

  // If admin is authenticated, allow access
  if (isAdminAuth) {
    return true;
  }

  // For regular users, verify user status with backend
  return auth.refreshUser().pipe(
    map(() => true),
    catchError((error) => {
      // If user doesn't exist (404) or is unauthorized (401), logout and redirect
      if (error.status === 404 || error.status === 401) {
        auth.logout();
        router.navigate(['/auth/login']);
      }
      return of(false);
    })
  );
};
